export default class Passenger { // 常旅客类 + 乘客
  constructor(details) {
    let credential = null
    if (details.Credentials) {
      credential = details.Credentials.filter(a => a.CredentialType === details.DefaultCredentialType)[0]
      // details.Credential = details.Credentials.filter(a => a.CredentialType === details.DefaultCredentialType)[0]
    }

    if (credential) {
      // 根据证件类型里对应的字段更新是否现在是是否必填 证件签署国 // -1不限 0中文 1英文
      let NameType = credential ? Number(credential.NameType) : -1
      if (NameType === 0) {
        details.DefaultNameType = 0
      } else if (NameType === 1) {
        details.DefaultNameType = 1
      }
    }

    if (details.DefaultNameType === 0) {
      details.Name = details.ChName
    } else {
      if (details.LastName && details.FirstName) {
        details.Name = `${details.LastName}/${details.FirstName}`
      } else {
        details.Name = `${details.LastName || ''}${details.FirstName || ''}`
      }
    }
    // details.Name = details.DefaultNameType === 0 ? details.ChName : `${details.LastName}/${details.FirstName}`;
    return details
  }
}
